import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Modal, ModalHeader, Banner, ModalButtonRow, Button } from "@flatfile/design-system";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalSpinner from "./ModalSpinner.js";
import { ModalText, ErrorContainer } from "./Styles.js";
const BulkRowActionsModalContent = (props) => {
  const [submitting, setSubmitting] = useState(false);
  const { text, hasError, onSubmit } = props;
  const { t } = useTranslation();
  const handleSubmit = async () => {
    setSubmitting(true);
    await onSubmit();
    setSubmitting(false);
  };
  const handleCancel = () => {
    if (props.onCancel)
      props.onCancel();
    props.closeModal();
  };
  const isSubmitting = submitting || props.isSubmitting;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ModalHeader, { children: text == null ? void 0 : text.heading }),
    /* @__PURE__ */ jsx(ModalText, { children: text == null ? void 0 : text.description }),
    (text == null ? void 0 : text.errorMessage) && hasError ? /* @__PURE__ */ jsx(ErrorContainer, { children: /* @__PURE__ */ jsx(Banner, { variant: "error", title: "", message: text == null ? void 0 : text.errorMessage }) }) : null,
    /* @__PURE__ */ jsxs(ModalButtonRow, { children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "tertiary-border",
          onPress: handleCancel,
          isDisabled: isSubmitting,
          label: (text == null ? void 0 : text.cancelButtonText) ?? "Cancel"
        }
      ),
      isSubmitting ? /* @__PURE__ */ jsx(ModalSpinner, { text: text == null ? void 0 : text.loadingText }) : /* @__PURE__ */ jsx(
        Button,
        {
          type: "submit",
          onPress: handleSubmit,
          label: (text == null ? void 0 : text.confirmButtonText) ?? t("jobs.submit.button.defaultLabel")
        }
      )
    ] })
  ] });
};
const BulkRowActionsModal = (props) => {
  const content = BulkRowActionsModalContent(props);
  return /* @__PURE__ */ jsx(Modal, { content });
};
export {
  BulkRowActionsModal
};
